<ng-container #prefix></ng-container>
<div class="label" min-width-0>
  <ng-content></ng-content>
</div>
<ng-container #suffix></ng-container>
